export default __webpack_public_path__ + "static/1367-63d84fac03e336d88548284f276092d2.jpg";